module.exports = __webpack_public_path__ + "static/img/06.4a77489.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour3/06.jpg
// module id = bcVa
// module chunks = 0